module.exports = __webpack_public_path__ + "img/livecamera_venice.36a77e86.png";